import { useLayoutEffect } from "react";
import { useAccountData } from "./useAccountData";
import { useNavigate } from "react-router";

export function useFeatureFlag(feature: string) {
  const accountData = useAccountData();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (accountData && !accountData.features[`web_next_${feature}`]) {
      navigate("/", { replace: true });
    }
  }, [accountData]);

  return false;
}
